import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import z from 'zod'
import SetPasswordForm from '@/components/forms/set-password-form/set-password-form'
import { AuthSplitLayout } from '@/components/layout/auth-split-layout'
import { Button } from '@/components/ui/button'

const searchSchema = z.object({
  oobCode: z.string().optional(),
})

export const Route = createFileRoute('/reset-password')({
  validateSearch: searchSchema,
  component: ResetPasswordPage,
})

function ResetPasswordPage() {
  const { oobCode } = Route.useSearch()
  const { t } = useTranslation()

  return (
    <AuthSplitLayout>
      <div className="flex-1 flex flex-col justify-center w-full md:flex-none md:mb-6 md:space-y-6">
        <div className="flex flex-col gap-y-3">
          <h1 className="heading-1 text-center">{t('resetPasswordPage.title')}</h1>
          <p className="body-1 text-text-secondary text-center">
            {t('resetPasswordPage.description')}
          </p>
        </div>
      </div>

      <div className="w-full gap-6 flex flex-col">
        {oobCode ? (
          <SetPasswordForm oobCode={oobCode} />
        ) : (
          <div className="flex flex-col gap-4 items-center text-center">
            <p className="body-2 text-text-secondary">{t('resetPasswordPage.invalidLink')}</p>
            <Link to="/forgot-password" className="w-full">
              <Button variant="background" className="w-full">
                {t('resetPasswordPage.requestNewLinkButton')}
              </Button>
            </Link>
          </div>
        )}
      </div>
    </AuthSplitLayout>
  )
}
